import $ from 'jquery'
import Base from 'luminate/src/modules/base'

/**
 * Binds a copy of the module instance to the element using jQuery's element data system.
 *
 * @param e
 */
Base.events.init = function(e)
{
	if(!this.$owner)
	{
		$(this.$element).data(this.constructor.directive, this)
	}
}



// WEBPACK FOOTER //
// ./source/scripts/extensions/base.js